import React from "react";

import { config } from "@app/config";

import { SearchspringCollectionProvider } from "@app/providers/searchspring";

import { ResultGrid } from "@app/components/result-grid";
import { ResultFooter } from "@app/components/result-footer";
import { ResultControls } from "@app/components/result-controls";

export type Props = {
  config: typeof config;
  collection: any;
};

export function CollectionGrid({ collection }: Props) {
  return (
    <SearchspringCollectionProvider category="products" handle={collection.handle} resultsPerPage="24">
      <div className="px-4 md:px-12">
        <hr className="border-neutrals-grey-4" />
      </div>
      <ResultControls />
      <ResultGrid />
      <ResultFooter />
    </SearchspringCollectionProvider>
  );
}
